const bannerKey = (userId: string) => `rivetai_claude_connector_banner_dismissed:${userId}`;

export function isClaudeConnectorBannerDismissed(userId: string | undefined): boolean {
  if (typeof window === "undefined" || !userId) {
    return true;
  }
  return window.localStorage.getItem(bannerKey(userId)) === "1";
}

export function dismissClaudeConnectorBanner(userId: string): void {
  if (typeof window === "undefined") {
    return;
  }
  window.localStorage.setItem(bannerKey(userId), "1");
}
